// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"234":"ad3cd8ca","353":"61a1381d","594":"f6f6abdb"}[chunkId] + ".js";
};